const initialState = {
  reservationFormModal: {
    isVisible: false
  }
};

export default initialState;
